import { CapapgProviders } from '@generated/graphql';
import { PgProvider } from '../../../../../../@types/@iamport-type/RequestPay/RequestPayTypes';

const pgProviderToCapaEnumMap = (pgProvider: PgProvider) => {
  switch (pgProvider) {
    case 'nice':
      return CapapgProviders.Nicepay;
    default:
      throw new Error('지원하지 않는 결제사입니다.');
  }
};

export { pgProviderToCapaEnumMap };
